import { render } from "./HighlightButton.vue?vue&type=template&id=2f146e64&scoped=true"
import script from "./HighlightButton.vue?vue&type=script&lang=js"
export * from "./HighlightButton.vue?vue&type=script&lang=js"

import "./HighlightButton.vue?vue&type=style&index=0&id=2f146e64&scoped=true&lang=css"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f146e64"]])

export default __exports__